import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgModule } from '@angular/core';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { MenuImagesComponent } from '../core/components/menu-images/menu-images.component';
import { CoreModule } from '../core/core.module';
import { AlertComponent } from './components/alert/alert.component';
import { HomeComponent } from './components/home/home.component';
import { ItemDetailComponent } from './components/item-detail/item-detail.component';
import { ItemDrinkMidleComponent } from './components/item-drink-midle/item-drink-midle.component';
import { ItemDrinksComponent } from './components/item-drinks/item-drinks.component';
import { ItemGalleryComponent } from './components/item-gallery/item-gallery.component';
import { ItemImageComponent } from './components/item-image/item-image.component';
import { ItemListAdditionsComponent } from './components/item-list-additions/item-list-additions.component';
import { ItemListComponent } from './components/item-list/item-list.component';
import { ItemOnlyDescriptionComponent } from './components/item-only-description/item-only-description.component';
import { ItemSimpleListComponent } from './components/item-simple-list/item-simple-list.component';
import { ItemVideoComponent } from './components/item-video/item-video.component';
import { ItemComponent } from './components/item/item.component';
import { MenuDetailComponent } from './components/menu-detail/menu-detail.component';
import { MenuInfinitiScrollComponent } from './components/menu-infiniti-scroll/menu-infiniti-scroll.component';
import { MenuListButtonsComponent } from './components/menu-list-buttons/menu-list-buttons.component';
import { MenuPdfComponent } from './components/menu-pdf/menu-pdf.component';
import { MenuComponent } from './components/menu/menu.component';
import { PartnersComponent } from './components/partners/partners.component';
import { PreviewMenuComponent } from './components/preview-menu/preview-menu.component';
import { RecommendComponent } from './components/recommend/recommend.component';
import { SeparatorComponent } from './components/separator/separator.component';
import { ScrollableItemDirective } from './directive/scrolleable-item.directive';
import { MatTabScrollToCenterDirective } from './directive/scrolling.directive';
import { MenuRoutingModule } from './menu-routing.module';
import { MenuStorageService } from './services/menu-storage.service';
import { MenuService } from './services/menu.service';
import { MenuSelectorsComponent } from './components/menu-selectors/menu-selectors.component';

@NgModule({
  declarations: [
    MenuComponent,
    MenuDetailComponent,
    MatTabScrollToCenterDirective,
    MenuImagesComponent,
    ItemImageComponent,
    ItemGalleryComponent,
    ItemDrinksComponent,
    ItemListComponent,
    ItemDetailComponent,
    ItemComponent,
    ScrollableItemDirective,
    MenuInfinitiScrollComponent,
    PreviewMenuComponent,
    HomeComponent,
    ItemDrinkMidleComponent,
    RecommendComponent,
    AlertComponent,
    ItemSimpleListComponent,
    MenuListButtonsComponent,
    PartnersComponent,
    ItemVideoComponent,
    ItemOnlyDescriptionComponent,
    MenuPdfComponent,
    ItemListAdditionsComponent,
    SeparatorComponent,
    MenuSelectorsComponent],
  imports: [
    LazyLoadImageModule,
    MenuRoutingModule,
    ScrollingModule,
    CoreModule
  ],
  providers: [MenuStorageService, MenuService]
})
export class MenuModule { }
